import { Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { serverHost } from "../config";
import Cookies from 'universal-cookie';

const ProtectedRoute = ({component: Component, ...rest}) =>
{
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    if(!isAuthenticated)
    {
        localStorage.clear();
        const cookies = new Cookies();
        const expiration = new Date(Date.now() + 15 * 60 * 1000);
        cookies.set("initialRoute", window.location.href.substring(window.location.origin.length), {
            path: "/",
            expires: expiration,
            sameSite: "lax"
        });
        window.location.href = `${serverHost}/login`;
        return (<></>);
    }

    return(
        <Route {...rest} render={props =>
            {
                if(true)
                {
                    return <Component {...props} />;
                }
            }}
        />
    );
};

export default ProtectedRoute;